module.exports = __webpack_public_path__ + "static/Canela-ThinItalic-979bf99dbb19394e5f6a337d4612444b.otf";